import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "setting-preferences" }
const _hoisted_2 = { class: "toggle-wrapper" }

import SettingsBlock from './SettingsBlock.vue';
import { ref } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'OtherPreferences',
  setup(__props) {

const showTimestamps = ref(false);

return (_ctx: any,_cache: any) => {
  const _component_ToggleSwitch = _resolveComponent("ToggleSwitch")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(SettingsBlock, { title: "Timestamp" }, {
      default: _withCtx(() => [
        _cache[2] || (_cache[2] = _createElementVNode("p", { class: "subtitle" }, "Toggle the ‘Show Speaker Timestamp’ option to display or hide timestamps for each speaker’s diarization in the transcript.", -1)),
        _createElementVNode("div", _hoisted_2, [
          _cache[1] || (_cache[1] = _createElementVNode("p", null, " Show Speaker Timestamp", -1)),
          _createVNode(_component_ToggleSwitch, {
            modelValue: showTimestamps.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((showTimestamps).value = $event))
          }, null, 8, ["modelValue"])
        ])
      ]),
      _: 1,
      __: [2]
    })
  ]))
}
}

})